import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';
import type { OnsaMvpVmrPopulatorDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/motor';
import { isLoggedOnSelector } from '../recoil/selectors/isLoggedOnSelector';
export const useGetVMRData = (): {
    getVMRData: (carDTO: OnsaMvpVmrPopulatorDTO) => Promise<OnsaMvpVmrPopulatorDTO>;
} => {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const isLoggedOn = useRecoilValue(isLoggedOnSelector);

    const getVMRData = async (
        carVMRData: OnsaMvpVmrPopulatorDTO
    ): Promise<OnsaMvpVmrPopulatorDTO> => {
        return await OnlineSalesUnauthenticated.getVMRData(
            jobNumber,
            sessionId,
            carVMRData,
            !isLoggedOn
        );
    };

    return { getVMRData };
};
